import {Autocomplete, Checkbox, FormControl, styled} from '@mui/material'
import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import * as product from '../modules/insurance/InsuranceProducts/redux/productRedux'
import {CustomInputField} from './InputField'
import {CustomInputLable} from './SelectField'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import {getConfig} from '../../_metronic/i18n/Metronici18n'

type Props = {
  options: any
  label: string
  defaultValue: string | null
  id?: string
  formName?: string
  tabName?: string
  required?: boolean
  handleValueSelected?: (value: string) => void
  validateField?: boolean
  autoCompleteReadOnly?: boolean
  resetValue?: boolean
  isGroup?: boolean
}

export const AutoCompleteInput = styled(CustomInputField)(({theme}) => ({
  '& .MuiAutocomplete-input': {
    padding: '8px 4px 8px 6px !important',
    backgroundColor: 'inherit',
  },
  '& .MuiAutocomplete-inputRoot': {
    padding: '1px !important',
  },
  // '& .MuiAutocomplete-endAdornment': {
  //   top: 'calc(50% - 12px)',
  // },
}))

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />

export const AutoComplete: React.FC<Props> = ({
  options,
  label,
  defaultValue,
  id,
  formName,
  tabName,
  required,
  handleValueSelected,
  validateField,
  autoCompleteReadOnly,
  resetValue,
  isGroup,
}) => {
  const [value, setValue] = useState<string | null>('')
  const [inputValue, setInputValue] = useState('')
  const dispatch = useDispatch()

  const handleSaveDataRedux = (newValue: string | null) => {
    if (value) {
      if (newValue !== JSON.parse(JSON.stringify(value)).value || resetValue) {
        if (formName && formName.toLowerCase().includes('formperson')) {
          let data = {
            key: id ? id : '',
            value: newValue ? newValue : '',
            tab: tabName ? tabName : '',
            form: formName,
          }
          dispatch(form.actions.addProductInfo(data))
        } else if (formName && formName.toLowerCase().includes('auto')) {
          let data = {
            key: id ? id : '',
            value: newValue ? newValue : '',
            tab: tabName ? tabName : '',
            form: formName,
          }
          dispatch(auto.actions.addAutoInfos(data))
        } else if (formName && formName.toLowerCase().includes('moto')) {
          let data = {
            key: id ? id : '',
            value: newValue ? newValue : '',
            tab: tabName ? tabName : '',
            form: formName,
          }
          dispatch(moto.actions.addMotoInfos(data))
        } else if (
          formName &&
          (formName.toLowerCase().includes('product') ||
            formName.toLowerCase().includes('cargo') ||
            formName.toLowerCase().includes('marine') ||
            formName.toLowerCase().includes('property'))
        ) {
          let data = {
            key: id ? id : '',
            value: newValue ? newValue : '',
            tab: tabName ? tabName : '',
            form: formName ? formName : '',
          }
          dispatch(product.actions.addProductInfos(data))
        } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
          let data = {
            field: id ? id : '',
            value: newValue ? newValue : '',
            filterForm: formName,
          }
          dispatch(filter.actions.updateFilterInfo(data))
        } else if (formName === 'user') {
          let data = {
            key: id ? id : '',
            value: newValue ? newValue : '',
          }
          dispatch(user.actions.addUserInfo(data))
        }
      }
    } else {
      if (formName && formName.toLowerCase().includes('formperson')) {
        let data = {
          key: id ? id : '',
          value: newValue ? newValue : '',
          tab: tabName ? tabName : '',
          form: formName,
        }
        dispatch(form.actions.addProductInfo(data))
      } else if (formName && formName.toLowerCase().includes('auto')) {
        let data = {
          key: id ? id : '',
          value: newValue ? newValue : '',
          tab: tabName ? tabName : '',
          form: formName,
        }
        dispatch(auto.actions.addAutoInfos(data))
      } else if (formName && formName.toLowerCase().includes('moto')) {
        let data = {
          key: id ? id : '',
          value: newValue ? newValue : '',
          tab: tabName ? tabName : '',
          form: formName,
        }
        dispatch(moto.actions.addMotoInfos(data))
      } else if (
        formName &&
        (formName.toLowerCase().includes('product') ||
          formName.toLowerCase().includes('cargo') ||
          formName.toLowerCase().includes('marine') ||
          formName.toLowerCase().includes('property'))
      ) {
        let data = {
          key: id ? id : '',
          value: newValue ? newValue : '',
          tab: tabName ? tabName : '',
          form: formName ? formName : '',
        }
        dispatch(product.actions.addProductInfos(data))
      } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
        let data = {
          field: id ? id : '',
          value: newValue ? newValue : '',
          filterForm: formName,
        }
        dispatch(filter.actions.updateFilterInfo(data))
      } else if (formName === 'user') {
        let data = {
          key: id ? id : '',
          value: newValue ? newValue : '',
        }
        dispatch(user.actions.addUserInfo(data))
      }
    }
  }

  const handleChangeValue = (newValue: string | null) => {
    setValue(newValue)
    if (newValue) handleSaveDataRedux(JSON.parse(JSON.stringify(newValue)).value)
    else handleSaveDataRedux(newValue)
    if (handleValueSelected) {
      if (newValue) handleValueSelected(JSON.parse(JSON.stringify(newValue)).value)
      else handleValueSelected('')
    }
  }

  useEffect(() => {
    if (resetValue) {
      handleSaveDataRedux(defaultValue)
    }
  }, [resetValue])

  useEffect(() => {
    if (defaultValue) {
      let test = ''
      if (options.length > 0) test = options.find((o: any) => o.value === defaultValue)
      if (test) {
        setValue(test)
        handleSaveDataRedux(defaultValue)
      } else {
        setValue('')
      }
    } else setValue('')
  }, [defaultValue, options])

  return (
    <div className='field-wrapper' key={id}>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <CustomInputLable id={id} htmlFor={id} aria-label='test'>
          {label}
          {required && <span className='input-require'> *</span>}
        </CustomInputLable>
        <Autocomplete
          value={value}
          // defaultValue={defaultValue}
          onChange={(event: any, newValue: string | null) => {
            handleChangeValue(newValue)
          }}
          groupBy={(option: any) => (isGroup ? option.group : null)}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue)
          }}
          id={id}
          options={
            isGroup ? options.sort((a: any, b: any) => -b.group.localeCompare(a.group)) : options
          }
          // renderOption={(props, option: any) => (
          //   <li style={{marginLeft: option?.isChild ? '10px' : 0}} {...props}>{option.label}</li>
          // )}
          getOptionDisabled={(option: any) => option.disable}
          renderOption={(props: any, option: any, {selected}) => {
            const {key, ...optionProps} = props
            return (
              <li style={{marginLeft: option?.isChild ? '10px' : 0}} key={key} {...optionProps}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{marginRight: 8}}
                  checked={selected}
                />
                {option.label}
              </li>
            )
          }}
          renderInput={(params) => (
            <AutoCompleteInput {...params} label={label} error={validateField} />
          )}
          isOptionEqualToValue={(option: any, value: any) =>
            option.value === (value ? value.value : '')
          }
          getOptionLabel={(option: any) =>
            getConfig().selectedLang === 'vi'
              ? option.name || option.label || ''
              : option.name || option.labelEng || option.label || ''
          }
          readOnly={autoCompleteReadOnly}
          disabled={autoCompleteReadOnly}
        />
      </FormControl>
    </div>
  )
}
